export const LINE_CHART = {
  options: {
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    scales: {
      yAxes: [{
        ticks: {
            beginAtZero: true
        }
      }]
    }
  },
  data: {
    labels: [ "Red", "Blue", "Yellow", "Green", "Purple", "Orange" ],
    datasets: [{
        label: 'Running Balance',
        data: [12, 19, 3, 5, 2, 3],
        fill: false,
        backgroundColor: "#6f2c91",
        borderColor: "#6f2c91",
        lineTension: 0,
        borderWidth: 1,
        pointBorderWidth: 3,
        pointBorderColor: 'white',
        pointBackgroundColor: '#6f2c91',
        pointRadius: 6,
        pointHoverBorderColor: '#6f2c91',
        pointHoverBackgroundColor: 'white',
        pointHoverBorderWidth: 3
    }]
  }
};

export const BAR_CHART = {
  options: {
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    elements: {
        point: {
          radius: 8,
          backgroundColor: "rgba(255, 255, 255, 1)",
          borderColor: "rgba(66, 20, 95, 1)",
          borderWidth: 2,
          hoverRadius: 10
        },
    },
    scales: {
      yAxes: [{
        ticks: {
            beginAtZero: true
        }
      }]
    }
  },
  data: {
    datasets: [
      {
        label: "Money In",
        fill: true,
        data: [70],
        backgroundColor: "#00adb9",
      },
      {
        label: "Money Out",
        fill: true,
        data: [40],
        backgroundColor: "#b90063",
      }
    ]
  }
};
